import { useEffect, useState } from "react";

function DDUMainLapTimes({value, hasPlayerBestLap}) {
    const [firstLapDone, changeFirstLapDone] = useState(false);
    const estimatedLap = value?.["estimated-lap"];

    const getLapMs = (timeStr) => {
        if (timeStr === "--:--:---") {return 0;}
        
        const [mins, secs, ms] = timeStr.split(':').map(Number);
        return (mins * 60000) + (secs * 1000) + ms;
    };

    useEffect(() => {
        if (estimatedLap == "-:--:---") {
            changeFirstLapDone(false);
        } else {
            changeFirstLapDone(true);
        }
    }, [estimatedLap])

    return (
        <>
            <p className={`${value["pit-limiter"] === 1 ? "bg-[#0743c2]" : "bg-[#0a0f14]"} absolute text-white p-1 top-[-13px] px-2 text-[12px] font-bold`}>LAP TIMES</p>

            {   firstLapDone ? 
                    <div className="flex flex-col">
                        <h1 className={`${value["estimated-lap"] === "-:--:---" ? "text-[#2d3242]" : value["is-valid-lap"] != 1 ? "text-[#cb4343]" : getLapMs(value["estimated-lap"]) <= getLapMs(value["best-time"]) ? "text-[#5dc759]" : "text-[#fffa7d]"} text-center text-[45px] font-bold`}>{value["estimated-lap"]}</h1>
                        <p className="text-right uppercase relative mt-[-15px] text-[12px] font-bold text-[#6c6c6c]">Estimated Lap</p>
                    </div>

                :

                    <div className="flex flex-col">
                        <h1 className={`${value["current-time"] === "-:--:---" ? "text-[#2d3242]" : value["is-valid-lap"] != 1 ? "text-[#cb4343]" : "text-[#5dc759]"} text-center text-[45px] font-bold`}>{value["current-time"]}</h1>
                        <p className="text-right uppercase relative mt-[-15px] text-[12px] font-bold text-[#6c6c6c]">Current Lap</p>
                    </div>
            }

            <div className="flex flex-col">
                <h1 className={`${value["last-time"] === "-:--:---" ? "text-[#2d3242]" : (value["last-time"] === value["best-time"] && hasPlayerBestLap) ? "text-[#b95be3]" : "text-[#a9b3d2]"} text-center text-[45px] font-bold`}>{value["last-time"]}</h1>
                <p className="text-right uppercase relative mt-[-15px] text-[12px] font-bold text-[#6c6c6c]">Last Lap</p>
            </div>

            <div className="flex flex-col">
                <h1 className={`${value["best-time"] === "-:--:---" ? "text-[#2d3242]" : hasPlayerBestLap === true ? "text-[#b95be3]" : "text-[#a9b3d2]"} text-center text-[45px] font-bold`}>{value["best-time"]}</h1>
                <p className="text-right uppercase relative mt-[-15px] text-[12px] font-bold text-[#6c6c6c]">Best Lap</p>
            </div>
        </>
    );
}

export default DDUMainLapTimes;